import type { EventName } from "@lit/react";
import { Slider as SliderElement, type SliderEventMap as _SliderEventMap, } from "@vaadin/slider/vaadin-slider.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SliderElement, };
export type SliderEventMap = Readonly<{
    onChange: EventName<_SliderEventMap["change"]>;
    onInput: EventName<_SliderEventMap["input"]>;
    onInvalidChanged: EventName<_SliderEventMap["invalid-changed"]>;
    onValidated: EventName<_SliderEventMap["validated"]>;
    onValueChanged: EventName<_SliderEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as SliderEventMap;
export type SliderProps = WebComponentProps<SliderElement, SliderEventMap>;
export const Slider = createComponent({
    elementClass: SliderElement, events, react: React, tagName: "vaadin-slider"
});
